import { render, staticRenderFns } from "./SacChamado.vue?vue&type=template&id=75820b7e&"
import script from "./SacChamado.vue?vue&type=script&lang=js&"
export * from "./SacChamado.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./SacChamado.vue?vue&type=style&index=1&id=75820b7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports